import { Card, CardContent, Grid, Typography } from '@mui/material'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { MuiButtonVariants, OPButton } from '../../../OPcomponents/OPButton'
import { OPSwitch } from '../../../OPcomponents/OPSwitch'
import { useCVSettings } from './CVSettingsContext'

interface CVCardProps {
  title: string
  description: string
  children?: ReactNode
  isEnabled?: boolean
  toggleName?: string
  onToggleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  disableToggle?: boolean
  showResetDefaultButton?: boolean
}

const CVCard: React.FC<CVCardProps> = ({
  title,
  description,
  children,
  isEnabled,
  toggleName,
  onToggleChange,
  disableToggle = false,
  showResetDefaultButton = false,
}) => {
  const { t } = useTranslation()
  const { resetToDefaultSettings } = useCVSettings()
  // If isEnabled is undefined, we don't show a toggle switch
  const showToggle = isEnabled !== undefined && toggleName && onToggleChange

  return (
    <Card variant='outlined'>
      <CardContent>
        <Grid container justifyContent='space-between' alignItems='center'>
          <Grid item>
            <Typography variant='h5' component='div' className='myskill--font__titlefont sini'>
              {title}
            </Typography>
            <Typography sx={{ mb: 2 }} color='text.secondary' variant='body2'>
              {description}
            </Typography>
          </Grid>
          {showToggle && (
            <Grid item>
              <OPSwitch
                name={toggleName}
                isChecked={isEnabled}
                label={t('CVTemplates.Include')}
                disabled={disableToggle}
                onChange={onToggleChange}
              />
            </Grid>
          )}
          {showResetDefaultButton && (
            <Grid item>
              <OPButton
                label={t('CVTemplates.DefaultSettings')}
                buttonVariant={MuiButtonVariants.secondary_outlined}
                onClick={resetToDefaultSettings}
              />
            </Grid>
          )}
        </Grid>

        {/* Only render children if there are any or if isEnabled is undefined/true */}
        {(isEnabled === undefined || isEnabled) && children && (
          <Grid container direction='column' sx={{ marginTop: '1rem', marginLeft: '4px' }}>
            {children}
          </Grid>
        )}
      </CardContent>
    </Card>
  )
}

export default CVCard
